import { useAuth } from '../context/AuthProvider';

const useUser = () => {
  const { userData } = useAuth();
  return userData || {}; // Retorna objeto vacío si aún no hay token
};

export default useUser;